import React, { Component } from "react";
import "./ViolationsTable.css";
import firebase from "firebase/app";
import firestore from "firebase/firestore";
// import { firebaseConfig } from './Components/FirebaseConfig';
import { firebaseConfig } from "../FirebaseConfig";
import {
    Paper,
    Table,
    TableContainer,
    TableHead,
    TableCell,
    TableRow,
    TableBody,
  } from "@material-ui/core";
import { GoSearch } from "react-icons/go";
import DeleteIcon from "@material-ui/icons/Delete";
import ViolationsPopover from '../ViolationsPopover'
import SimpleDateTime  from 'react-simple-timestamp-to-date';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
toast.configure();


export class ViolationsUnpaidTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      violations: [],
      place: {},
      uid: null,
      first_name: null,
      cnic: null,
      fine: null,
      last_name: null,
      violation_status: null,
      // violation_payment:null,
      zone_id: null,
      show: false,
      exit_time: null,
      exit_zone: null,
      model_f_name: null,
      model_l_name: null,
      model_e_time: null,
      // model_e_zone:null,
      zoneName: [],
      search:''
    };
    this.onInputChange = this.onInputChange.bind(this);

  }

  componentDidMount() {
    this.getViolationData();
  }

  getViolationData = async () => {
    //get violations data from firebase
    console.log("func chal raha hai k nhe ")
    

    if (this.state.search == null || this.state.search == "" || this.state.search == '') {
      let tempdata = [];

      const db = firebase.firestore();
      const snapshot = await db
      .collection("violations")
      .orderBy("exit_time", "desc")
      .get();

      snapshot.forEach((doc) => {
        let tempobj = {
          uid: doc.id,
          first_name: doc.data().first_name,
          last_name: doc.data().last_name,
          cnic: doc.data().cnic,
          fine: doc.data().fine,
          violation_status: doc.data().violation_status,
          zone_id: doc.data().zone_id,
          exit_time: doc.data().exit_time,
          exit_zone: doc.data().exit_zone,
          email: doc.data().email,
        };
        // tempdata.push(tempobj);
        if(tempobj.violation_status == "Unpaid")
          {
            tempdata.push(tempobj);
          }
          else
          {
            console.log("NOt working")
          }
          // tempdata.push(tempobj);
      });
      this.setState({ violations: []});
      this.setState({ violations: tempdata });
      
      //   });
      //   this.setState({ violations: tempdata });
    } else {

      const db = firebase.firestore();
      let tempdata = [];

      const snapshot = await db
      .collection("violations")
      .orderBy("cnic", "desc")
      .where('cnic', '>=', this.state.search)
      .where('cnic', '<=', this.state.search+"\uf8ff")
      .get();

      snapshot.forEach((doc) => {
        let tempobj = {
          uid: doc.id,
          first_name: doc.data().first_name,
          last_name: doc.data().last_name,
          cnic: doc.data().cnic,
          fine: doc.data().fine,
          violation_status: doc.data().violation_status,
          zone_id: doc.data().zone_id,
          exit_time: doc.data().exit_time,
          exit_zone: doc.data().exit_zone,
          email: doc.data().email,
        };
        // tempdata.push(tempobj);
        if(tempobj.violation_status == "Unpaid")
          {
            tempdata.push(tempobj);
          }
          else
          {
            console.log("NOt working")
          }
      });

      this.setState({ violations: []});
      this.setState({ violations: tempdata });
      
    }
      
      // .where('cnic', '>=', this.state.search)
      // .where('cnic', '<=', this.state.search+"\uf8ff")
      // .startAt([this.state.search])
      // .endAt([this.state.search+"\uf8ff"])
     

    // snapshot.forEach((doc) => {
    //   let tempobj = {
    //     uid: doc.id,
    //     first_name: doc.data().first_name,
    //     last_name: doc.data().last_name,
    //     cnic: doc.data().cnic,
    //     fine: doc.data().fine,
    //     violation_status: doc.data().violation_status,
    //     zone_id: doc.data().zone_id,
    //     exit_time: doc.data().exit_time,
    //     exit_zone: doc.data().exit_zone,
    //     email: doc.data().email,
    //   };
    //   tempdata.push(tempobj);
    // });
    // this.setState({ violations: tempdata });
  };

  onInputChange = async(event) => {

    // let string = event.target.value.toLower
    if (event.target.value.length < 1) {
      event.target.value = '';
      // this.getViolationData()     
      console.log("if ki value =", event.target.value)
      this.setState({ [event.target.name]: event.target.value.toLowerCase()});

      let tempdata = [];

      const db = firebase.firestore();
      const snapshot = await db
      .collection("violations")
      .orderBy("exit_time", "desc")
      .get();

      snapshot.forEach((doc) => {
        let tempobj = {
          uid: doc.id,
          first_name: doc.data().first_name,
          last_name: doc.data().last_name,
          cnic: doc.data().cnic,
          fine: doc.data().fine,
          violation_status: doc.data().violation_status,
          zone_id: doc.data().zone_id,
          exit_time: doc.data().exit_time,
          exit_zone: doc.data().exit_zone,
          email: doc.data().email,
        };
        // tempdata.push(tempobj);
        if(tempobj.violation_status == "Unpaid")
          {
            tempdata.push(tempobj);
          }
          else
          {
            console.log("NOt working")
          }
 
      });
      this.setState({ violations: []});
      this.setState({ violations: tempdata });

    } else {
      console.log("else ki value =", event.target.value)
      this.setState({ [event.target.name]: event.target.value.toLowerCase()});
    }
    this.getViolationData()      
}


// getViolationData = async () => {
//   //get violations data from firebase
//   let tempdata = [];
//   const db = firebase.firestore();
//   const snapshot = await db.collection("violations").orderBy('exit_time', "desc").get();

//   snapshot.forEach((doc) => {
//     let tempobj = {
//       uid: doc.id,
//       first_name: doc.data().first_name,
//       last_name: doc.data().last_name,
//       cnic: doc.data().cnic,
//       fine: doc.data().fine,
//       violation_status: doc.data().violation_status,
//       zone_id: doc.data().zone_id,
//       exit_time: doc.data().exit_time,
//       exit_zone: doc.data().exit_zone,

//     };
//     if(tempobj.violation_status == "Unpaid")
//     {
//       tempdata.push(tempobj);
//     }
//     else
//     {
//       console.log("NOt working")
//     }
//     // tempdata.push(tempobj);
//   });
//   this.setState({ violations: tempdata });
// };

addViolationData = async (add_id, status) => {
  this.setState({ status: "yes" });
  const db = firebase.firestore();
  const docRef = db.collection("violations").doc(add_id);
  await docRef.update({
    // violation_payment: payment,
    violation_status: status,
  });
  toast("Violation Status Updated Successfully", {
    position: toast.POSITION.BOTTOM_CENTER,
    autoClose: 5000,
    hideProgressBar: true,
  });
};

deleteViolationData = async (delete_id) => {
  const db = firebase.firestore();
  const res = await db.collection("violations").doc(delete_id).delete();
  toast("Zone Deleted Successfull", {
    position: toast.POSITION.BOTTOM_CENTER,
    autoClose: 5000,
    hideProgressBar: true,
  });
  // await this.reloadPage();
  this.getViolationData();
};

dateConvertor(value){
  if(value == null)
  {
    // console.log("mar gye")
    return(
      <a>--</a>
    )
  }
  else
  {
      // console.log('else value: ' + value)
      // this.dateTime(value)
      return(
            <SimpleDateTime dateSeparator="/" format="DMY" timeSeparator=":" meridians="1" >
        {value/1000}
      </SimpleDateTime>
      // <p>fefeaf</p>
      )
  
  }
}

  render() {
    return (
      <Paper className={"violationPaperCss"}>
        <div
          style={{
            height: "6.2vh",
            width: "100%",
            backgroundColor: "white",
            display:'flex',
            justifyContent:'flex-end',
            alignItems:'center',
            // marginBottom:'5%'
          }}
        >
          <div className={'violationSearchInputDiv'}>
          <input
            className={'violationSearchInput'}
            type={"text"}
            placeholder={"Search data..."}
            name={"search"}
            value={this.state.search}
            onChange={this.onInputChange}
          />
          <GoSearch style={{ height: 20, width: 20, color: '#21618C' }} />                            
          </div>
          
        </div>
        <TableContainer className={"violationTableContainerCss"}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell align="center" className={"violationTableCell"}>
                  NAME
                </TableCell>
                <TableCell align="center" className={"violationTableCell"}>
                  CNIC
                </TableCell>
                <TableCell align="center" className={"violationTableCell"}>
                  FINE
                </TableCell>
                <TableCell align="center" className={"violationTableCell"}>
                  STATUS
                </TableCell>
                <TableCell align="center" className={"violationTableCell"}>
                  DESCRIPTION
                </TableCell>
                <TableCell align="center" className={"violationTableCell"}>
                  ACTIONS
                </TableCell>
                
              </TableRow>
            </TableHead>

            <TableBody>
              {this.state.violations.map((value) => (
                <TableRow>
                  <TableCell align="center">{value.first_name}
                                           {' '}
                                          {value.last_name}
                                          </TableCell>
                  <TableCell align="center" sortDirection="asc">{value.cnic}</TableCell>
                  <TableCell align="center" sortDirection="asc">{value.fine}</TableCell>
                  <TableCell align="center" sortDirection="asc">{value.violation_status}</TableCell>
                  <TableCell align="center" sortDirection="asc">
                    {/* <ViolationsPopover exit_zone={value.exit_zone} exit_time={this.dateConvertor(value.exit_time)}/> */}
                    <ViolationsPopover exit_zone={value.zone_id} exit_time={value.exit_time}/>
                  </TableCell>
                  <TableCell align="center">
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <DeleteIcon
                      className={'violationEditDeleteIcon'}
                      onClick={() => {
                          this.deleteViolationData(value.uid);
                        }}
                      />
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    );
  }
}

export default ViolationsUnpaidTable
